import React, { useEffect, useState } from "react";
import "./BackToTop.scss";
import { IBackToTop } from "./BackToTop.type";
import { IonIcon } from "@ionic/react";
import {
  CARRIER_ASSIGNED_MODULE_WEB,
  CARRIER_TENDERED_MODULE_WEB,
} from "../constants";
import { useHistory } from "react-router";
import { isMobile } from "../common";

export default function BackToTop(props: IBackToTop) {
  const history: any = useHistory();
  const [backToTopBTN, setBackToTopBTN] = useState(false);
  const elem = document?.querySelector(
    props?.elementClassName || ".sni-body-container"
  );
  useEffect(() => {
    backToTopBTN && setBackToTopBTN(false);
  }, []);
  useEffect(() => {
    const pathname =
      (history && history.location && history.location.pathname) || "";
    if (!isMobile && props?.isVisible) {
      elem?.addEventListener(
        "scroll",
        () => {
          if (elem?.scrollTop > 300) {
            setBackToTopBTN(true);
          } else {
            setBackToTopBTN(false);
          }
        },
        false
      );
    } else {
      elem?.removeEventListener("scroll", () => setBackToTopBTN(false));
    }
  }, [history?.location?.pathname]);
  const scrollUp = () => {
    elem?.scrollTo({
      top: 0,
      behavior: props?.scrollBehaviour,
    });
    setBackToTopBTN(false);
  };
  return (
    <div
      className={`BackToTop ${(props?.isVisible && backToTopBTN) ? "show" : "hide"}`}
      data-testid="BackToTop"
      onClick={scrollUp}
    >
      <IonIcon className="uparrow" src="assets/icon/grid-up-arrow-thin.svg" />
    </div>
  );
}
